const NS = 'SiteHeaderWidget';
const CLS = 'siteHeaderWidget';

export class SiteHeaderWidget {
	constructor(element) {
		this.element = element;
		this.$element = $(element);

		this.$element.on(`${CLS}.siteHeaderTopWidget.marketUpdateButton.addClass`, (event) => {
			let $element = $(event.currentTarget);
			$element.find(`.siteHeaderTopWidget`).trigger(`siteHeaderTopWidget.marketUpdateButton.addClass`, {});
		});

		this.$element.on(`${CLS}.siteHeaderTopWidget.marketUpdateButton.click`, (event) => {
			let $element = $(event.currentTarget);
			$element.find(`.siteHeaderTopWidget`).trigger(`siteHeaderTopWidget.marketUpdateButton.toggleClass`, {});
			$element.find(`.siteHeaderMicronWidget`).trigger(`siteHeaderMicronWidget.marketUpdateButton.toggle`, {});
		});

		this.$element.on(`${CLS}.siteHeaderMicronWidget.close`, (event) => {
			let $element = $(event.currentTarget);
			$element.find(`.siteHeaderTopWidget`).trigger(`siteHeaderTopWidget.marketUpdateButton.removeClass`, {});
			$element.find(`.siteHeaderMicronWidget`).trigger(`siteHeaderMicronWidget.marketUpdateButton.close`, {});
		});

		this.$element.on('siteHeaderWidget.siteHeaderMicronWidget.menuWidgets.close', (event) => {
			let $element = $(event.currentTarget);
			$element.find(`.siteHeaderBottomWidget`).trigger(`siteHeaderBottomWidget.menuWidgets.close`, {});
		});

		this.initSticky();
	}

	initSticky() {
		let $element = this.$element;
		let $elementClone = null;
		let oldScrollY = 0;
		let scrollY;

		let toggleSticky = () => {
			let offsetTop = $('.siteHeaderWidget').first().offset().top;

			if(scrollY > offsetTop) {
				if(_.isNil($elementClone)) {
					$elementClone = $element.clone(true, true);
					$element.before($elementClone);

					$element.css({
						position: 'fixed',
						top: '0',
						left: '0',
						right: '0',
						zIndex: '100'
					});

					$elementClone.attr('site-header-widget-placeholder-clone', 'true');
					$elementClone.css({
						visibility: 'hidden'
					});
				}
			}
			else {
				if($elementClone) {
					$elementClone.remove();
					$elementClone = null;

					$element.css({
						position: ''
					});
				}
			}
		};

		let initScrollEvents = () => {
			scrollY = Math.round(window.scrollY);
			toggleSticky();
			oldScrollY = scrollY;
		};

		$(window).on('scroll', _.debounce(() => {
			// Don’t trigger scrolling event when overlay is activated
			if(!$(document.body).hasClass('hasOverlay')) {
				initScrollEvents();
			}
		}, 50, { leading: true, trailing: true }));

		initScrollEvents();
	}
}
